export default __webpack_public_path__ + "static/media/LuisSuares.e3fb1c91.png";